import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

type ReqData = { productId?: number; categoryId?: number };

const variantProductAttributes = async (data: ReqData) =>
  axios.get(
    Routes.VARIANT_PRODUCT_ATTRIBUTES +
      `?product_id=${data?.productId}&category_id=${data?.categoryId}`
  );

export const useVariantProductAttributes = (params: ReqData) =>
  useQuery({
    queryKey: [
      Keys.VARIANT_PRODUCT_ATTRIBUTES_QRY,
      params?.productId,
      params?.categoryId,
    ],
    queryFn: () => variantProductAttributes(params),
    enabled:
      params.productId && params.categoryId && params.categoryId ? true : false,
  });
